import Icon from '@ant-design/icons'
import type { customIconProps } from './types'

function deleteSVG(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="11"
      height="14"
      viewBox="0 0 11 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.60743 4.17856H1.464C1.06967 4.17856 0.75 4.49823 0.75 4.89256V10.6071C0.75 11.7906 1.70939 12.75 2.89286 12.75H7.17857C7.74689 12.75 8.29194 12.5242 8.6938 12.1224C9.09566 11.7205 9.32143 11.1755 9.32143 10.6071V4.89256C9.32143 4.49823 9.00176 4.17856 8.60743 4.17856Z"
        stroke="#AD1D00"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.60709 2.46429L6.98652 1.224C6.84144 0.93366 6.5448 0.750173 6.22023 0.75H3.85109C3.52652 0.750173 3.22989 0.93366 3.0848 1.224L2.46423 2.46429H7.60709Z"
        stroke="#AD1D00"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.35697 7.03544C4.35697 6.62122 4.02118 6.28544 3.60697 6.28544C3.19275 6.28544 2.85697 6.62122 2.85697 7.03544H3.60697H4.35697ZM2.85697 9.89229C2.85697 10.3065 3.19275 10.6423 3.60697 10.6423C4.02118 10.6423 4.35697 10.3065 4.35697 9.89229H3.60697H2.85697ZM7.21456 7.03544C7.21456 6.62122 6.87878 6.28544 6.46456 6.28544C6.05035 6.28544 5.71456 6.62122 5.71456 7.03544H6.46456H7.21456ZM5.71456 9.89229C5.71456 10.3065 6.05035 10.6423 6.46456 10.6423C6.87878 10.6423 7.21456 10.3065 7.21456 9.89229H6.46456H5.71456ZM7.60725 1.71426C7.19303 1.71426 6.85725 2.05005 6.85725 2.46426C6.85725 2.87847 7.19303 3.21426 7.60725 3.21426V2.46426V1.71426ZM9.32153 3.21426C9.73575 3.21426 10.0715 2.87847 10.0715 2.46426C10.0715 2.05005 9.73575 1.71426 9.32153 1.71426V2.46426V3.21426ZM2.46429 3.21426C2.8785 3.21426 3.21429 2.87847 3.21429 2.46426C3.21429 2.05005 2.8785 1.71426 2.46429 1.71426V2.46426V3.21426ZM0.75 1.71426C0.335786 1.71426 0 2.05005 0 2.46426C0 2.87847 0.335786 3.21426 0.75 3.21426V2.46426V1.71426ZM3.60697 7.03544H2.85697V9.89229H3.60697H4.35697V7.03544H3.60697ZM6.46456 7.03544H5.71456V9.89229H6.46456H7.21456V7.03544H6.46456ZM7.60725 2.46426V3.21426H9.32153V2.46426V1.71426H7.60725V2.46426ZM2.46429 2.46426V1.71426H0.75V2.46426V3.21426H2.46429V2.46426Z"
        fill="#AD1D00"
      />
    </svg>
  )
}

export default function deleteIcon(props: customIconProps) {
  return <Icon component={deleteSVG} {...props} onClick={props.onClick} />
}
